export default "__VITE_ASSET__DPRbd_MP__"